import { Injectable } from '@angular/core';

import { select, Store, Action } from '@ngrx/store';

import * as fromNote from './note.reducer';
import * as NoteSelectors from './note.selectors';
import * as NoteActions from './note.actions';
import { APIService } from '../../services/api/api.service';
import { tap } from 'rxjs';
import { INote } from '@care-portals/api-interfaces';

@Injectable()
export class NoteFacade {
  loaded$ = this.store.pipe(select(NoteSelectors.getNotesLoaded));
  notes$ = this.store.pipe(select(NoteSelectors.getNoteEntities));
  appointmentNotes$ = this.store.pipe(
    select(NoteSelectors.getAppointmentNotes)
  );
  allNotes$ = this.store.pipe(select(NoteSelectors.getAllNote));
  totalCount$ = this.store.pipe(select(NoteSelectors.getNotesTotalCount));
  filters: any;

  constructor(
    private store: Store<fromNote.NotePartialState>,
    private readonly apiService: APIService
  ) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadNotes(filters: any) {
    this.filters = filters;
    this.dispatch(NoteActions.loadNotes({ filters: { ...filters } }));
  }

  upsertNote(note: Partial<INote>, updateAppointmentNotes?: boolean) {
    this.dispatch(NoteActions.upsertNote({ note, updateAppointmentNotes }));
  }

  getAppointmentNote(appointmentId: string) {
    this.dispatch(NoteActions.loadAppointmentNotes({ appointmentId }));
  }

  getOrderNote(orderId: String) {
    return this.apiService.getNotes({ order: orderId }).pipe(
      tap(notes => {
        if (notes.length > 0)
          this.dispatch(NoteActions.loadNotesSuccess({ notes }));
      })
    );
  }

  clearAppointmentNotes() {
    this.dispatch(NoteActions.clearAppointmentNotes());
  }
}
